import { Partial } from '@40seas/entities/common';
import { HeronCompany } from './heron-company.entity';

export class UpdateHeronCompanyDto extends Partial(HeronCompany) {}
